import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AppBootstrapService {
  readonly splashHidden = signal(false);
}
